import { render } from "./complain.vue?vue&type=template&id=93dba6e0&scoped=true"
import script from "./complain.vue?vue&type=script&lang=js"
export * from "./complain.vue?vue&type=script&lang=js"

import "./complain.vue?vue&type=style&index=0&id=93dba6e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93dba6e0"]])

export default __exports__